import React from "react";
import ListMod from "../../../Component/Redesign/ListMod";
import {Datagrid, FunctionField, TextField, TopToolbar} from "react-admin";
import CrudMod from "../../../Component/Layouts/Button/CrudMod";
import {convertedDateWithTimeGMT} from "../../../Functions/ConvertedDate";
import CreateGradientButtonMod from "../../../Component/Layouts/Button/CreateGradientButtonMod";

export const EventsList = (props) => {
    const LocalsField = ({record}) => {
        if (!record.locales || !record.locales.length) {
            return '';
        }

        const lastElement = record.locales.length - 1;
        return record.locales.map((item, i) => (
            <span key={i}>{item.locale}{i === lastElement ? '' : ', '}</span>
        ))
    };

    const ListActions = ({className}) => {
        return (<TopToolbar className={className}>
            <div className="actionsWrap">
                <div className="addCategoryBtnWrap">
                    <CreateGradientButtonMod label={'Add New Event'}/>
                </div>
            </div>
        </TopToolbar>);
    };

    return <div className="customTableWrap pt-32">
        <ListMod
            {...props}
            title={'Events'}
            actions={<ListActions/>}
            sort={{field: 'start_date', order: 'ASC'}}
        >
            <Datagrid bulkActionButtons={false}>
                <TextField label='Name' source="name" sortBy="name"/>
                <FunctionField label="Show Date" source="start_date" render={(record) => {
                    return (convertedDateWithTimeGMT(record.start_date));
                }}/>
                <FunctionField label="End Date" source="end_date" render={(record) => {
                    return (convertedDateWithTimeGMT(record.end_date));
                }}/>
                <FunctionField label='Localization' source="locales" sortBy="locales" render={(record) => {
                    return <LocalsField record={record}/>
                }}/>
                <FunctionField label="" source="actions" render={(record) => {
                    return <CrudMod edit="true" del="true" id={record.id} record={record}/>;
                }}/>
            </Datagrid>
        </ListMod>
    </div>
}